<div class="app-mobile-first-layout" [class.nav-collapsed]="isNavCollapsed" [class.handset]="isHandset">
    <!-- Mobile Navigation Component -->

    <div class="main-content">
        <!-- Top bar -->
        @if (appTitle) {
        <div class="top-bar" [class.handset]="isHandset" [class.desktop]="!isHandset">
            <div class="top-bar-content">
                @if (isHandset) {
                <!-- Mobile header with menu button placeholder -->
                <div class="mobile-header-spacer"></div>
                }
                <h1 class="page-title">{{ appTitle }}</h1>
            </div>
        </div>
        }

        <!-- Main content area -->
        <div class="content-area" [class.handset]="isHandset" [class.desktop]="!isHandset">
            <ng-content></ng-content>
        </div>

        <!-- Bottom Navigation for Mobile -->
        @if (isHandset) {
        <div class="bottom-nav-container">
            <ng-content select="[slot=bottom-nav]"></ng-content>
        </div>
        }
    </div>
</div>